// ── Booking length ────────────────────────────────────────────────────
// GIGGS charges for TIME, nothing else, and time is always expressed in
// HOURS — never minutes — everywhere a person sees it. A booking is a number
// of hours in half-hour steps, with a floor of one hour per booked service.

export const HOUR_STEP = 0.5;
export const MIN_SERVICE_HOURS = 1;

// Half-hour steps, at least half an hour. The one-hour-per-service floor is
// applied on top of this by the booking screens.
export const isValidBookingHours = (hours) => {
  const n = Number(hours);
  if (!Number.isFinite(n) || n < HOUR_STEP) return false;
  return Math.abs(n * 2 - Math.round(n * 2)) < 0.0001;
};

// Round to the nearest half hour, never below one step.
export const roundToHourStep = (hours) => {
  const n = Number(hours);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.max(HOUR_STEP, Math.round(n * 2) / 2);
};

// Display only. Always hours: "1 hr" / "1.5 hrs" / "3 hrs".
export const formatHours = (hours) => {
  const n = Math.round((Number(hours) || 0) * 100) / 100;
  if (n <= 0) return '0 hrs';
  return `${n} ${n === 1 ? 'hr' : 'hrs'}`;
};
